/**
 * clients_controller.js — Address autocomplete for the clients list page (Stimulus).
 *
 * Ports static/js/clients.js (attachOnce('clientsListeners') + turbo:load) to an
 * element-scoped controller. The original attachOnce registered a turbo:load
 * listener once per page session that re-attached AddressAutocomplete to the
 * new-client form and the edit-client modal on every navigation. Stimulus gives
 * us that for free: connect() runs each time the controller element enters the
 * DOM (initial load AND Turbo navigations onto the clients page), so we simply
 * (re)attach the autocompletes in connect(). No document listeners to bind, so
 * disconnect() is a no-op beyond what the framework already does.
 *
 * data-controller="clients" hosts on #clients-page, which already carries
 * data-region (the country code AddressAutocomplete needs).
 *
 * Source (to delete): static/js/clients.js
 * Template:           templates/clients.html
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
        connect() {
            var region = this.element.dataset.region || '';

            // New client form autocomplete
            var addressInput = document.getElementById('address_input');
            if (addressInput) {
                new AddressAutocomplete(addressInput, {
                    country: region,
                    onSelect: function (suggestion) {
                        document.getElementById('street').value    = suggestion.street   || '';
                        document.getElementById('city').value      = suggestion.city     || '';
                        document.getElementById('postcode').value  = suggestion.postcode || '';
                        document.getElementById('state').value     = suggestion.state    || '';
                        document.getElementById('latitude').value  = suggestion.latitude || '';
                        document.getElementById('longitude').value = suggestion.longitude || '';
                    }
                });
            }

            // Edit client modal autocomplete
            var editAddressInput = document.getElementById('editAddressInput');
            if (editAddressInput) {
                var autocompleteSelected = false;

                editAddressInput.addEventListener('input', function () {
                    if (!autocompleteSelected) {
                        // User is manually typing — clear component fields so address_input is used
                        document.getElementById('editStreet').value    = '';
                        document.getElementById('editCity').value      = '';
                        document.getElementById('editPostcode').value  = '';
                        document.getElementById('editState').value     = '';
                        document.getElementById('editLatitude').value  = '';
                        document.getElementById('editLongitude').value = '';
                    }
                    autocompleteSelected = false;
                });

                new AddressAutocomplete(editAddressInput, {
                    country: region,
                    onSelect: function (suggestion) {
                        autocompleteSelected = true;
                        document.getElementById('editStreet').value    = suggestion.street   || '';
                        document.getElementById('editCity').value      = suggestion.city     || '';
                        document.getElementById('editPostcode').value  = suggestion.postcode || '';
                        document.getElementById('editState').value     = suggestion.state    || '';
                        document.getElementById('editLatitude').value  = suggestion.latitude || '';
                        document.getElementById('editLongitude').value = suggestion.longitude || '';
                    }
                });
            }
        }
}
